import * as React from "react";
import { locKeys } from "components/flexComponents/WizardFlightPWA/components/l10n";
import { PreferredClassProps } from "components/shared/PreferredClass/typings";
import { observer } from "mobx-react";
import {
  UitkMenu,
  UitkMenuTrigger,
  UitkMenuContainer,
  PositionType,
  UitkMenuList
} from "uitk-react-menu";
import { UitkLink, UitkLinkAlign } from "uitk-react-link";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";

export const PreferredClass = observer((props: PreferredClassProps) => {
  const setFlightClassLabel = () => {
    const flightClassCode = props.wizardState.flightClassCode;

    switch (flightClassCode) {
      case "p":
        return props.l10n.formatText(locKeys.flightPreferredClassPremiumEconomy);
      case "b":
        return props.l10n.formatText(locKeys.flightPreferredClassBusiness);
      case "f":
        return props.l10n.formatText(locKeys.flightPreferredClassFirstClass);
      case "e":
        return props.l10n.formatText(locKeys.flightPreferredClassEconomy);
    }

    return locKeys.flightPreferredClassEconomy;
  };

  return (
    <UitkMenu
      isOpen={props.isPreferredClassMenuOpen}
      onTriggerClick={props.onPreferredClassMenuTriggerClick}
    >
      <UitkMenuTrigger>
        <UitkLink iconPos={UitkLinkAlign.RIGHT}>
          <button type="button">
            {setFlightClassLabel()}
            <UitkIcon name="expand_more" size={UitkIconSize.SMALL} />
          </button>
        </UitkLink>
      </UitkMenuTrigger>
      <UitkMenuContainer position={PositionType.LEFT}>
        <UitkMenuList
          items={[
            {
              attributes: {
                role: "menuItem",
                tabindex: 0
              },
              className: "uitk-list-item",
              label: props.l10n.formatText(locKeys.flightPreferredClassEconomy),
              typeAnchor: true,
              onClick: props.onPreferredClassMenuItemClick("e")
            },
            {
              attributes: {
                role: "menuItem",
                tabindex: 0
              },
              className: "uitk-list-item",
              label: props.l10n.formatText(locKeys.flightPreferredClassPremiumEconomy),
              typeAnchor: true,
              onClick: props.onPreferredClassMenuItemClick("p")
            },
            {
              attributes: {
                role: "menuItem",
                tabindex: 0
              },
              className: "uitk-list-item",
              label: props.l10n.formatText(locKeys.flightPreferredClassBusiness),
              typeAnchor: true,
              onClick: props.onPreferredClassMenuItemClick("b")
            },
            {
              attributes: {
                role: "menuItem",
                tabindex: 0
              },
              className: "uitk-list-item",
              label: props.l10n.formatText(locKeys.flightPreferredClassFirstClass),
              typeAnchor: true,
              onClick: props.onPreferredClassMenuItemClick("f")
            }
          ]}
        />
      </UitkMenuContainer>
    </UitkMenu>
  );
});
